import { useEffect } from 'react';

const useClickOutside = (
  ref: React.RefObject<HTMLElement | null>,
  onClickOutside: () => void,
) => {
  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      setTimeout(() => {
        if (ref.current && !ref.current.contains(event.target as Node)) {
          onClickOutside();
        }
      }, 0); // 👈 렌더링 이후 DOM 업데이트 후 실행
    };

    document.addEventListener('mousedown', handleClick);
    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  }, [ref, onClickOutside]);
};

export default useClickOutside;
